const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSafari(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 268.59,
    r: 243.41,
    style: {
      opacity: 0.08
    },
    fill: "#000000",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 256,
    x2: 256,
    y1: 10.4,
    y2: 514,
    gradientTransform: "matrix(1 0 0 -1 0 514)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F2F2F2"
    },
    stopColor: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    },
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 251.8,
    r: 251.8,
    style: {
      fill: "url(#a)"
    },
    fill: ""
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.08
    }
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 256,
    x2: 256,
    y1: 10.393,
    y2: 514,
    gradientTransform: "matrix(1 0 0 -1 0 514)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    },
    stopColor: "#000000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    },
    stopColor: "#000000;stop-opacity:0"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M256 0C116.929 0 4.197 112.732 4.197 251.803S116.929 503.607 256 503.607s251.803-112.732 251.803-251.803S395.071 0 256 0zm0 486.82c-129.586 0-235.016-105.43-235.016-235.016S126.414 16.787 256 16.787s235.016 105.43 235.016 235.016S385.586 486.82 256 486.82z",
    style: {
      fill: "url(#b)"
    },
    fill: ""
  })), /*#__PURE__*/React.createElement("path", {
    d: "M256 0C116.929 0 4.197 112.732 4.197 251.803S116.929 503.607 256 503.607s251.803-112.732 251.803-251.803S395.071 0 256 0zm0 495.213c-134.429 0-243.41-108.98-243.41-243.41S121.571 8.393 256 8.393s243.41 108.98 243.41 243.41S390.429 495.213 256 495.213z",
    style: {
      opacity: 0.16
    },
    fill: "#000000",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 256,
    x2: 256,
    y1: 35.58,
    y2: 488.82,
    gradientTransform: "matrix(1 0 0 -1 0 514)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#3871E9"
    },
    stopColor: "#3871e9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#61C5F6"
    },
    stopColor: "#61c5f6"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 251.8,
    r: 226.62,
    style: {
      fill: "url(#c)"
    },
    fill: ""
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.16
    }
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 256,
    x2: 256,
    y1: 35.574,
    y2: 488.82,
    gradientTransform: "matrix(1 0 0 -1 0 514)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    },
    stopColor: "#000000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    },
    stopColor: "#000000;stop-opacity:0"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M256 25.18c-125.163 0-226.623 101.46-226.623 226.623S130.837 478.426 256 478.426s226.623-101.46 226.623-226.623S381.163 25.18 256 25.18zm0 444.853c-120.521 0-218.229-97.708-218.229-218.229S135.479 33.574 256 33.574s218.229 97.708 218.229 218.229S376.521 470.033 256 470.033z",
    style: {
      fill: "url(#d)"
    },
    fill: ""
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.36
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M256 83.238a3.5 3.5 0 0 1-3.5-3.5V46.164a3.5 3.5 0 1 1 7 0v33.574a3.5 3.5 0 0 1-3.5 3.5zM231.344 68.063a3.5 3.5 0 0 1-3.466-3.043l-2.191-16.636a3.5 3.5 0 0 1 6.94-.914l2.191 16.636a3.5 3.5 0 0 1-3.474 3.957zM183.734 80.83a3.5 3.5 0 0 1-3.235-2.161l-6.429-15.511a3.5 3.5 0 0 1 6.467-2.681l6.429 15.511a3.5 3.5 0 0 1-3.232 4.842zM141.038 105.48a3.493 3.493 0 0 1-2.779-1.369l-10.223-13.32a3.499 3.499 0 1 1 5.553-4.261l10.223 13.32a3.499 3.499 0 0 1-2.774 5.63zM106.175 140.338a3.48 3.48 0 0 1-2.128-.724l-13.321-10.223a3.499 3.499 0 1 1 4.261-5.553l13.321 10.223a3.499 3.499 0 0 1-2.133 6.277zM81.524 183.037c-.446 0-.9-.086-1.339-.268l-15.511-6.429a3.5 3.5 0 1 1 2.681-6.467l15.511 6.429a3.5 3.5 0 0 1-1.342 6.735zM68.764 230.652c-.152 0-.306-.01-.461-.03l-16.636-2.191a3.5 3.5 0 1 1 .914-6.94l16.636 2.191a3.5 3.5 0 0 1-.453 6.97zM211.462 89.105a3.5 3.5 0 0 1-3.378-2.595l-8.687-32.432a3.5 3.5 0 0 1 6.762-1.812l8.687 32.432a3.5 3.5 0 0 1-3.384 4.407zM169.971 106.287a3.5 3.5 0 0 1-3.035-1.75l-16.787-29.075a3.5 3.5 0 0 1 6.062-3.5l16.787 29.075a3.5 3.5 0 0 1-3.027 5.25zM134.329 133.632a3.49 3.49 0 0 1-2.475-1.025l-23.737-23.736a3.5 3.5 0 1 1 4.95-4.95l23.737 23.736a3.5 3.5 0 0 1-2.475 5.975zM106.979 169.271a3.488 3.488 0 0 1-1.747-.469l-29.075-16.787a3.5 3.5 0 1 1 3.5-6.062l29.075 16.787a3.5 3.5 0 0 1-1.753 6.531zM89.803 210.769c-.299 0-.604-.039-.908-.12l-32.432-8.687a3.5 3.5 0 0 1 1.812-6.762l32.432 8.687a3.5 3.5 0 0 1-.904 6.882zM83.935 255.303H50.361a3.5 3.5 0 1 1 0-7h33.574a3.5 3.5 0 1 1 0 7zM52.119 282.146a3.5 3.5 0 0 1-.453-6.97l16.636-2.19a3.5 3.5 0 0 1 .914 6.94l-16.636 2.19c-.155.02-.309.03-.461.03zM66.016 334.001a3.5 3.5 0 0 1-1.342-6.734l15.511-6.429a3.5 3.5 0 1 1 2.681 6.467l-15.511 6.429a3.503 3.503 0 0 1-1.339.267zM92.859 380.491a3.499 3.499 0 0 1-2.133-6.276l13.321-10.223a3.497 3.497 0 0 1 4.907.646 3.499 3.499 0 0 1-.646 4.907l-13.321 10.223a3.48 3.48 0 0 1-2.128.723zM130.81 418.446a3.499 3.499 0 0 1-2.774-5.631l10.223-13.32a3.5 3.5 0 0 1 5.553 4.261l-10.223 13.32c-.69.9-1.729 1.37-2.779 1.37zM177.302 445.29a3.5 3.5 0 0 1-3.232-4.841l6.429-15.512a3.5 3.5 0 1 1 6.467 2.679l-6.429 15.512a3.501 3.501 0 0 1-3.235 2.162zM229.162 459.18a3.5 3.5 0 0 1-3.474-3.957l2.191-16.636a3.501 3.501 0 0 1 6.94.914l-2.191 16.636a3.5 3.5 0 0 1-3.466 3.043zM57.367 308.527a3.5 3.5 0 0 1-.904-6.882l32.432-8.688a3.501 3.501 0 0 1 1.812 6.762l-32.432 8.688c-.303.081-.608.12-.908.12zM77.911 358.124a3.5 3.5 0 0 1-1.754-6.532l29.075-16.787a3.5 3.5 0 0 1 3.5 6.062l-29.075 16.787a3.473 3.473 0 0 1-1.746.47zM153.177 433.396a3.5 3.5 0 0 1-3.028-5.251l16.787-29.075a3.5 3.5 0 1 1 6.062 3.5l-16.787 29.075a3.496 3.496 0 0 1-3.034 1.751zM202.779 453.936a3.5 3.5 0 0 1-3.383-4.406l8.687-32.433a3.5 3.5 0 0 1 6.762 1.81l-8.687 32.433a3.502 3.502 0 0 1-3.379 2.596zM256 460.942a3.5 3.5 0 0 1-3.5-3.5v-33.573a3.5 3.5 0 1 1 7 0v33.573a3.5 3.5 0 0 1-3.5 3.5zM282.837 459.18a3.5 3.5 0 0 1-3.465-3.043l-2.19-16.636a3.5 3.5 0 0 1 3.013-3.927 3.497 3.497 0 0 1 3.927 3.013l2.19 16.636a3.5 3.5 0 0 1-3.475 3.957zM334.698 445.29a3.5 3.5 0 0 1-3.234-2.161l-6.43-15.512a3.5 3.5 0 1 1 6.467-2.679l6.43 15.512a3.5 3.5 0 0 1-3.233 4.84zM381.191 418.446a3.493 3.493 0 0 1-2.779-1.369l-10.224-13.32a3.499 3.499 0 1 1 5.553-4.261l10.224 13.32a3.499 3.499 0 0 1-2.774 5.63zM419.141 380.491a3.478 3.478 0 0 1-2.128-.724l-13.32-10.223a3.5 3.5 0 0 1 4.261-5.553l13.32 10.223a3.5 3.5 0 0 1-2.133 6.277zM445.984 334.001c-.447 0-.9-.086-1.339-.268l-15.511-6.429a3.5 3.5 0 0 1 2.679-6.467l15.511 6.429a3.5 3.5 0 0 1-1.34 6.735zM459.882 282.146c-.152 0-.307-.01-.462-.03l-16.636-2.19a3.5 3.5 0 1 1 .914-6.94l16.636 2.19a3.5 3.5 0 0 1-.452 6.97zM309.221 453.936a3.5 3.5 0 0 1-3.379-2.596l-8.688-32.433a3.5 3.5 0 1 1 6.762-1.81l8.688 32.433a3.5 3.5 0 0 1-3.383 4.406zM358.822 433.396a3.499 3.499 0 0 1-3.034-1.751l-16.786-29.075a3.5 3.5 0 1 1 6.062-3.5l16.786 29.075a3.5 3.5 0 0 1-3.028 5.251zM401.408 400.711a3.491 3.491 0 0 1-2.475-1.025l-23.737-23.736a3.499 3.499 0 1 1 4.949-4.949l23.737 23.736a3.499 3.499 0 0 1-2.474 5.974zM434.089 358.124a3.477 3.477 0 0 1-1.747-.47l-29.074-16.787a3.5 3.5 0 1 1 3.5-6.062l29.074 16.787a3.5 3.5 0 0 1-1.753 6.532zM454.633 308.527c-.3 0-.604-.039-.907-.12l-32.433-8.688a3.5 3.5 0 0 1 1.81-6.762l32.433 8.688a3.5 3.5 0 0 1-.903 6.882zM461.64 255.303h-33.574a3.5 3.5 0 1 1 0-7h33.574a3.5 3.5 0 1 1 0 7z",
    style: {},
    fill: "#ffffff",
    "data-original": "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.64 255.303h-33.574a3.5 3.5 0 1 1 0-7h33.574a3.5 3.5 0 1 1 0 7zM443.236 230.652a3.5 3.5 0 0 1-.452-6.97l16.636-2.191a3.5 3.5 0 1 1 .914 6.94l-16.636 2.191c-.155.02-.309.03-.462.03zM430.476 183.037a3.5 3.5 0 0 1-1.34-6.735l15.511-6.429a3.5 3.5 0 1 1 2.679 6.467l-15.511 6.429a3.482 3.482 0 0 1-1.339.268zM405.826 140.338a3.499 3.499 0 0 1-2.133-6.276l13.32-10.223a3.498 3.498 0 0 1 4.907.646 3.499 3.499 0 0 1-.646 4.907l-13.32 10.223a3.483 3.483 0 0 1-2.128.723zM370.962 105.48a3.5 3.5 0 0 1-2.774-5.631l10.224-13.32a3.5 3.5 0 0 1 5.553 4.261l-10.224 13.32a3.491 3.491 0 0 1-2.779 1.37zM328.267 80.83a3.5 3.5 0 0 1-3.233-4.842l6.43-15.511a3.5 3.5 0 0 1 6.467 2.681l-6.43 15.511a3.502 3.502 0 0 1-3.234 2.161zM280.656 68.063a3.5 3.5 0 0 1-3.475-3.957l2.19-16.636a3.5 3.5 0 1 1 6.94.914l-2.19 16.636a3.5 3.5 0 0 1-3.465 3.043zM422.196 210.769a3.5 3.5 0 0 1-.903-6.882l32.433-8.687a3.5 3.5 0 0 1 1.81 6.762l-32.433 8.687c-.302.08-.607.12-.907.12zM405.021 169.271a3.5 3.5 0 0 1-1.753-6.531l29.074-16.787a3.5 3.5 0 0 1 3.5 6.062l-29.074 16.787a3.488 3.488 0 0 1-1.747.469zM342.03 106.287a3.5 3.5 0 0 1-3.028-5.25l16.786-29.075a3.5 3.5 0 1 1 6.062 3.5l-16.786 29.075a3.5 3.5 0 0 1-3.034 1.75zM300.537 89.105a3.5 3.5 0 0 1-3.383-4.407l8.688-32.432a3.5 3.5 0 0 1 6.762 1.812l-8.688 32.432a3.501 3.501 0 0 1-3.379 2.595zM256 83.238a3.5 3.5 0 0 1-3.5-3.5V46.164a3.5 3.5 0 1 1 7 0v33.574a3.5 3.5 0 0 1-3.5 3.5z",
    style: {},
    fill: "#ffffff",
    "data-original": "#ffffff"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M403.657 104.146 226.321 222.124 256 251.803z",
    style: {},
    fill: "#f4413d",
    "data-original": "#f4413d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.657 104.146 256 251.803l29.679 29.679z",
    style: {},
    fill: "#cc2b2b",
    "data-original": "#cc2b2b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.321 222.124 108.343 399.461 256 251.803z",
    style: {},
    fill: "#ffffff",
    "data-original": "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m108.343 399.461 177.336-117.979L256 251.803z",
    style: {},
    fill: "#d8d8d8",
    "data-original": "#d8d8d8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSafari);
export default __webpack_public_path__ + "static/media/safari.4471ad305b151d6f759395aee9170e4b.svg";
export { ForwardRef as ReactComponent };